import { render, staticRenderFns } from "./tagnav.vue?vue&type=template&id=5a53f92e&scoped=true"
import script from "./tagnav.vue?vue&type=script&lang=js"
export * from "./tagnav.vue?vue&type=script&lang=js"
import style0 from "./tagnav.vue?vue&type=style&index=0&id=5a53f92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a53f92e",
  null
  
)

export default component.exports